import React, { useEffect, useState, memo } from 'react';
import { isEmpty } from 'lodash';
import moment from 'moment';
import CircularProgress from '@mui/material/CircularProgress';
import styled from 'styled-components/macro';

import Calendar from 'components/general/Calendar';
import ClinicToolbar from 'components/general/Calendar/ClinicToolbar';
import { getAppointmentsByClinicId } from 'api/appointment';
import { formatAppointmentToCalendar } from 'helpers/format-appointment-to-calendar';
import { FlexCenter } from 'styles/flexbox';
import { index10 } from 'variables/z-index';

const LoadingContainer = styled(FlexCenter)`
  position: absolute;
  z-index: ${index10};
  width: 22em;
  height: 60em;

  .MuiCircularProgress-root {
    position: absolute;
  }
`;

const ClinicCalendar = memo(
  ({
    clinicStartDate,
    clinicEndDate,
    clinicMultiDays,
    clinicStatus,
    clinic,
    slots,
    setDate,
    concurrentSlots,
  }) => {
    const [selectedDate, setSelectedDate] = useState(
      moment(clinicStartDate).startOf('day').toDate(),
    );

    const [loadingAppointments, setLoadingAppointments] = useState(false);
    const [appointments, setAppointments] = useState([]);

    const fetchAppointments = async () => {
      setLoadingAppointments(true);

      const { data } = await getAppointmentsByClinicId(selectedDate, clinic.id);
      setLoadingAppointments(false);

      setAppointments(formatAppointmentToCalendar(data.data));
    };

    useEffect(async () => {
      if (!isEmpty(clinic)) {
        await fetchAppointments();
      }
    }, [clinic, selectedDate]);

    return (
      <>
        {loadingAppointments && (
          <LoadingContainer>
            <CircularProgress />
          </LoadingContainer>
        )}

        <Calendar
          fetchAppointments={fetchAppointments}
          appointments={appointments}
          defaultView="day"
          views={{
            day: true,
            month: false,
            week: false,
            agenda: false,
          }}
          date={selectedDate}
          components={{
            toolbar: (toolbar) => (
              <ClinicToolbar
                startDate={clinicStartDate}
                endDate={clinicEndDate}
                multiDays={clinicMultiDays}
                clinicStatus={clinicStatus}
                toolbar={toolbar}
                clinic={clinic}
                slots={slots}
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                fetchAppointments={fetchAppointments}
                concurrentSlots={concurrentSlots}
              />
            ),
          }}
          setDate={setDate}
        />
      </>
    );
  },
);

export default ClinicCalendar;
